import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import useTheme from "../../hooks/useTheme";
import Layout from "../Layout/Layout";
import RequireAuth from "../RequireAuth/RequireAuth";
import LoginPage from "../LoginPage/LoginPage";
import ChangePasswordPage from "../ChangePasswordPage/ChangePasswordPage";
import BandPage from "../BandPage/BandPage/BandPage";
import SongPage from "../SongPage/SongPage/SongPage";
import SumPage from "../SumPage/SumPage";
import AdminPage from "../AdminPage/AdminPage";
import MissingPage from "../MissingPage/MissingPage";
import GridPage from "../GridPage/GridPage/GridPage";
import ResetPasswordPage from "../ResetPasswordPage/ResetPasswordPage";
import StarsTable from "../StarsTable/StarsTable";
import StarsAdding from "../StarsAdding/StarsAdding/StarsAdding";
import AddConcertModal from "../AddingConcert/AddingConcert";
import ModalWindowWrapper from "../ModalOverlay/ModalWindowWrapper/ModalWindowWrapper";
import ConcertList from "../ConcertList/ConcertList";
import EditEventType from "../OtherList/EditEventType";
import "./App.css";
import EditConcertModal from "../AddingConcert/EditingConcert";
import BandList from "../BandList/BandList";
import OtherList from "../OtherList/OtherList";
import AchievementsSegment from "../AchievementsPage/AchievementsSegment/AchievementsSegment";
import AchievementsTeamsSegment from "../AchievementsPage/AchievementsTeamsSegment/AchievementsTeamsSegment";
function App() {
    return (
        <ThemeProvider theme={useTheme()}>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="" element={<LoginPage />} />
                    <Route
                        path="reset-password"
                        element={<ResetPasswordPage />}
                    />
                    <Route
                        path="ChangePasswordPage"
                        element={<ChangePasswordPage />}
                    />
                    <Route element={<RequireAuth />}>
                        <Route path="band" element={<BandPage />} />
                        <Route path="song" element={<SongPage />} />
                        <Route path="summary" element={<SumPage />} />
                        <Route path="admin" element={<AdminPage />} />
                        <Route path="/achievements" element={<AchievementsSegment />} />
                        <Route path="/achievementsTeams" element={<AchievementsTeamsSegment />} />
                        <Route path="concert/:concertId" element={<GridPage />}>
                            <Route path="add-event" element={<ModalWindowWrapper />} />
                        </Route>
                        <Route path ="/concertList" element={<ConcertList/>}/>
                        <Route path ="/bandList" element={<BandList/>}/>
                        <Route path ="/otherList" element={<OtherList/>}/>
                        <Route path="/editOtherType" element={<EditEventType/>}/>
                        <Route path="/artists1" element={<StarsAdding />} />
                        <Route path="/artists" element={<StarsTable />} />  
                        <Route path ="/concertAdd" element={<AddConcertModal/>}/>
                        <Route path="/concertEdit/:id" element={<EditConcertModal />} />
                    </Route>
                    <Route path="*" element={<MissingPage />} />
                </Route>
            </Routes>
        </ThemeProvider>
    );
}

export default App;
